import r, { useRef as t, useState as e, useEffect as n, useMemo as o, useCallback as i } from "react";

function a(r) {
  var o = t([]),
      i = t(0),
      a = t(performance.now()),
      c = t(0),
      u = e([]),
      p = u[0],
      l = u[1],
      f = function f() {
    var t = performance.now();

    if (i.current += 1, t > a.current + 1e3) {
      var e = t - a.current,
          n = Math.round(1e3 * i.current / e);
      if (o.current = o.current.concat(n), e > 1500) for (var u = 1; u <= (e - 1e3) / 1e3; u++) {
        o.current = o.current.concat(0);
      }
      o.current = o.current.slice(Math.max(o.current.length - r, 0)), l(o.current), i.current = 0, a.current = performance.now();
    }

    c.current = requestAnimationFrame(f);
  };

  n(function () {
    return c.current = requestAnimationFrame(f), function () {
      cancelAnimationFrame(c.current);
    };
  }, []);
  var g = (p.reduce(function (r, t) {
    return r + t;
  }, 0) / p.length).toFixed(2);
  return {
    fps: p,
    avgFps: g,
    maxFps: Math.max.apply(Math.max, p),
    currentFps: p[p.length - 1]
  };
}

var c = function c(t) {
  var e = t.top,
      n = void 0 === e ? 0 : e,
      c = t.left,
      u = void 0 === c ? 0 : c,
      p = t.bottom,
      l = void 0 === p ? "auto" : p,
      f = t.right,
      g = void 0 === f ? "auto" : f,
      h = t.width,
      m = void 0 === h ? 140 : h,
      x = t.height,
      d = void 0 === x ? 60 : x,
      b = a(Math.floor(m / 2)),
      s = b.fps,
      v = b.avgFps,
      F = b.maxFps,
      S = b.currentFps,
      y = function (r, t, e, n, a, c, u) {
    return {
      wrapperStyle: o(function () {
        return {
          zIndex: 999999,
          position: "fixed",
          width: r + 6 + "px",
          height: t + 30 + "px",
          padding: "3px",
          backgroundColor: "#21006f",
          color: "#26F0FD",
          fontSize: "1rem",
          lineHeight: "1.3rem",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 300,
          boxSizing: "border-box",
          top: e,
          right: n,
          bottom: a,
          left: c
        };
      }, [r, t, e, n, a, c]),
      graphStyle: o(function () {
        return {
          position: "absolute",
          left: "3px",
          right: "3px",
          bottom: "3px",
          height: t,
          backgroundColor: "#282844",
          MozBoxSizing: "border-box",
          boxSizing: "border-box"
        };
      }, [t]),
      barStyle: i(function (r, t) {
        return {
          position: "absolute",
          bottom: "0",
          right: 4 * (u - 1 - t) + "px",
          height: r + "px",
          width: "4px",
          backgroundColor: "#E200F7",
          MozBoxSizing: "border-box",
          boxSizing: "border-box"
        };
      }, [u])
    };
  }(m, d, n, g, l, u, s.length),
      z = y.graphStyle,
      w = y.barStyle,
      M = y.wrapperStyle;

  return r.createElement("div", {
    style: M
  }, r.createElement("span", null, S, " FPS (", v, " Avg)"), r.createElement("div", {
    style: z
  }, s.map(function (t, e) {
    return r.createElement("div", {
      key: e,
      style: w(d * t / F, e)
    });
  })));
};

export { c as FpsView, a as useFps };